// detect-autofill: https://github.com/matteobad/detect-autofill/blob/master/src/detect-autofill.js

/**
 * @TODO Polyfill or no CustomEvent on IE?
 *
 * @param {string} event
 * @param {any} params
 * @return {window.CustomEvent}
 */
function CustomEvent(event, params) {
  const e = document.createEvent('CustomEvent');
  const newParams = params || {
    bubbles: false,
    cancelable: false,
    detail: null,
  };
  e.initCustomEvent(
    event,
    newParams.bubbles,
    newParams.cancelable,
    newParams.detail
  );
  return e;
}

/**
 * Manage an input element when its value is autofilled
 * by the browser in the following steps:
 * - add [autofilled] attribute from event.target
 * - create 'onautofill' cancelable CustomEvent
 * - dispatch the Event
 *
 * @param {HTMLInputElement} element
 */
function autofill(element) {
  element.setAttribute('autofilled', '');

  const event = new window.CustomEvent('onautofill', {
    bubbles: true,
    cancelable: true,
    detail: null,
  });

  // no autofill if preventDefault is called
  if (!element.dispatchEvent(event)) {
    element.value = '';
  }
}

/**
 * Manage an input element when its autofilled value is
 * removed by the browser in the following steps:
 * - remove [autofilled] attribute from event.target
 *
 * @param {HTMLInputElement} element
 */
function cancelAutofill(element) {
  if (!element.hasAttribute('autofilled')) return;
  element.removeAttribute('autofilled');
}

/**
 * Handler for -webkit based browser that listen for a custom
 * animation create using the :pseudo-selector in the stylesheet.
 * Works with Chrome, Safari
 *
 * @event {AnimationEvent} event
 */
function onAnimationStart(event) {
  if (event.animationName === 'onautofillstart') {
    autofill(event.target);
  } else {
    cancelAutofill(event.target);
  }
}

/**
 * Handler for non-webkit based browser that listen for input
 * event to trigger the autofill-cancel process.
 * Works with Firefox, Edge, IE11
 *
 * @event {InputEvent} event
 */
function onInput(event) {
  if (event.inputType === 'insertReplacementText' || !('data' in event)) {
    autofill(event.target);
  } else {
    cancelAutofill(event.target);
  }
}

export function removeDetectAutoFill() {
  document.removeEventListener('animationstart', onAnimationStart, true);
  document.removeEventListener('input', onInput, true);
  if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = null;
  }
}

export default function () {
  document.addEventListener('animationstart', onAnimationStart, true);
  document.addEventListener('input', onInput, true);

  // polyfill CustomEvent for < IE11
  if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = CustomEvent;
  }
}

window.addEventListener('beforeunload', () => {
  removeDetectAutoFill();
});
